<template>
  <div>

    <v-card-text>

      <div class="login">
        <div class="login-card">
          <div class="relative">
            <div class="choose-select">
              <v-select
                :items="address_items"
                :label="$t('select')"
                single-line
                item-text="label"
                item-value="value"
                v-model="selected_address"
              >
              </v-select>
            </div>
            <div v-if="selected_address != 0">

              <v-select
                :items="province_items"
                single-line
                item-text="label"
                item-value="value"
                v-model="selected_province"
              >
              </v-select>
              <v-select
                :items="city_items"
                single-line
                item-text="label"
                item-value="value"
                v-model="selected_city"
              >
              </v-select>

              <v-select v-if="area_items.length >1"
                :items="area_items"
                single-line
                item-text="label"
                item-value="value"
                v-model="selected_area"
              >
              </v-select>

              <v-row>
                <v-btn  color="primary" v-on:click="open_map">{{ $t('location') }}</v-btn>
              </v-row>

              <div class="relative">
                <v-textarea
                  label="آدرس"
                  class="mt-2"
                  v-model="customer_address"
                  outlined
                ></v-textarea>
              </div>
              <v-row class="relative">
                <v-col cols="8">
                  <v-text-field
                    :label="$t('mobileNoNotRequire')"
                    v-model="customer_phone"
                    type="number"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <div class="choose-select">
                    <v-select
                      :items="phone_code_items"
                      :label="$t('select')"
                      single-line
                      item-text="label"
                      item-value="value"
                      v-model="selected_phone_code"
                    >
                    </v-select>
                  </div>
                </v-col>


              </v-row>

            </div>

            <v-menu
              bottom
              offset-y
            >

              <v-list>
                <!--              <v-list-item-->
                <!--                v-for="(item, i) in items"-->
                <!--                :key="i"-->
                <!--                @click="select_file(i)"-->
                <!--              >-->
                <!--                <v-list-item-title>{{ item.title }}</v-list-item-title>-->
                <!--              </v-list-item>-->
              </v-list>

            </v-menu>

            <v-list>
              <!--            <v-list-item-->
              <!--              v-for="(item, i) in files"-->
              <!--              :key="i"-->
              <!--            >-->
              <!--              <v-list-item-title>{{ item.title }}</v-list-item-title>-->
              <!--              <v-img :src="item.file" width="200px" height="200px"/>-->
              <!--              <v-icon v-on:click="delete_file(i)">-->
              <!--                mdi-close-->
              <!--              </v-icon>-->
              <!--            </v-list-item>-->
            </v-list>
          </div>
        </div>
      </div>

      <div class="row login">

        <v-row v-if="selected_address != 0">
          <v-btn  color="primary" v-on:click="save()">
            ثبت آدرس
          </v-btn>
        </v-row>
      </div>


    </v-card-text>
    <v-row justify="center">
      <v-dialog
        v-model="dialog_location"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >

        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="dialog_location = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('location') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="save_location()"
              >{{ $t('save') }}</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <!--          <div ref="map" id="map2" class="basemap"></div>-->
          <div ref="map" id="map2" class="basemap"></div>

        </v-card>
      </v-dialog>
    </v-row>
  </div>


</template>


<script>
  import {bus} from "../../main";
  import mapboxgl from "mapbox-gl";

  export default {
    name: 'Attachments',
    data() {
      return {
        accessToken: "pk.eyJ1Ijoiem9vZGtvbWFrIiwiYSI6ImNrOG1vYzVocjAxNm4zbWx2Zmk0bmJ1cHUifQ.rHAeQHubqjcMQTY2eQS1nA",
        user_addresses: [],
        phone_code_items: [],
        selected_phone_code: 1,

        province_items: [],
        selected_province: 0,

        city_items: [],
        selected_city: 0,

        area_items: [],
        selected_area: 0,

        selected_address: 0,
        customer_address: '',
        customer_phone: '',
        address_items: [],
        dialog_location: false,
        map: null,
        marker: null,
        user_location_lat: 0,
        user_location_lng: 0,
        addressInfo:null,
      }
    },

    mounted() {

      this.get_phone_prefix()
      this.get_provinces()
      this.get_user_addresses()

      mapboxgl.accessToken = this.accessToken;

      mapboxgl.setRTLTextPlugin(
        'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
        null,
        true // Lazy load the plugin
      );
    },
    watch: {
      "selected_province": function () {
        this.get_cities()
      },
      "selected_city": function () {
        this.get_areas()
      },
      "selected_address": function () {
        if(this.selected_province>0){
          this.addressInfo = null;
          this.get_address_info()
        }
      }
    },
    methods: {
      open_map() {

        var self = this;
        // init the map
        this.dialog_location = true;
        setTimeout(function () {
          self.map = new mapboxgl.Map({
            container: 'map2',
            style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
            center: [51.37734351262877, 35.697451890638886],
            zoom: 14 // starting zoom
          });
          self.map_function();
        }, 1000);

      },
      map_function() {
        var self = this;
        self.map.on('click', function (e) {
          if (self.user_location_lat == 0) {
            if (self.marker != null) {
              self.marker.remove();
            }
            self.marker = new mapboxgl.Marker({
              draggable: true
            })

              .setLngLat(e.lngLat)
              .addTo(self.map);
            self.user_location_lat = e.lngLat.lat;
            self.user_location_lng = e.lngLat.lng;

          }


          self.marker.on('dragend', self.onDragEnd);
          self.marker.on('dragstart', self.onDragStart);
          console.log('A click event has occurred at ' + e.lngLat);
          // }

        });

        self.map.on('load', function () {
        });
      },
      onDragEnd() {
        // var lngLat = marker.getLngLat();
        self.user_location_lat = this.marker.getLngLat().lat;
        self.user_location_lng = this.marker.getLngLat().lng;

      },

      onDragStart() {
        // var lngLat = marker.getLngLat();
        console.log("drag started");
        self.user_location_lat = this.marker.getLngLat().lat;
        self.user_location_lng = this.marker.getLngLat().lng;

      },
      get_user_addresses() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        console.log();
        const send_data = {
          "ReqId": this.$route.params.rec_id,
          "isFinalize": '1',
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetLastAddressByReqId', send_data, {})
          .then(response => {
            this.user_addresses = response.data.address;
            response.data.address.forEach(function (number) {

              var obj = {value: number.AddressId, label: number.AddressText}
              self.address_items.push(obj);
            });
            var obj = {value: -1, label: "آدرس جدید"}
            self.address_items.push(obj);
          }).catch(e => {
          this.errors.push(e);

        })


      },
      get_address_info() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        console.log();
        const send_data = {
          "RequestId": this.$route.params.rec_id,
          "AddressId": this.selected_address,

        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetAddressById', send_data, {})
          .then(response => {
            self.user_addresses = response.data.addressInfo;
            self.customer_address = response.data.addressInfo.AddressText;
            self.selected_province = parseInt(response.data.addressInfo.ProvinceId);
            self.selected_city = response.data.addressInfo.CityId;
            self.selected_area = response.data.addressInfo.AreaId;
            self.customer_phone = response.data.addressInfo.PhoneNo;
            self.selected_phone_code = parseInt(response.data.addressInfo.PhoneCode);
            self.user_location_lat = response.data.addressInfo.Lat;
            self.user_location_lng = response.data.addressInfo.Lng;

            // response.data.address.forEach(function (number) {
            //
            //   var obj = {value: number.AddressId, label: number.AddressText}
            //   self.address_items.push(obj);
            // });
            // var obj = {value: -1, label: "آدرس جدید"}
            // self.address_items.push(obj);
          }).catch(e => {
          this.errors.push(e);

        })


      },
      save() {
        if(this.selected_city == 0){
          bus.$emit('show_toast', [1500, self.$t('selectCity')])
          return false;
        }
        if(this.customer_address == ''){
          bus.$emit('show_toast', [1500, self.$t('insertAddress')])
          return false;
        }

        var passing_data = JSON.parse(localStorage.getItem('request_data'));
        if(passing_data.on_site_service == false && this.user_location_lat == 0){
          bus.$emit('show_toast', [1500, self.$t('selectLocation')])
          return false;

        }
        if(this.customer_phone == 0){
          bus.$emit('show_toast', [1500, self.$t('insertMobileNo')])
        return false;
        }

        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;

var last_address_id = 0;
if(this.selected_address > 0){
  last_address_id = this.selected_address;
}


        const send_data = {
          "UserId": user_id,
          "ReqAddrId": 0,
          "AddressText": this.customer_address,
          "RequestId": this.$route.params.rec_id,
          "ProvinceId": this.selected_province,
          "CityId": this.selected_city,
          "LastAddressId": last_address_id,
          "IsFinalize": 1,
          "PhoneNo": this.customer_phone,
          "PhoneCode": this.selected_phone_code,
          "FromTimeId": "0",
          "ToTimeID": "0",
          "AreaId": this.selected_area,
          "Lat": this.user_location_lat,
          "Lng": this.user_location_lng,
        };
console.log("json  send "+JSON.stringify(send_data));
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddReqAddress', send_data, {})
          .then(response => {
           if(response.data.error == 0){
             self.$router.push({name: 'home', params: {}})

           }else{
             bus.$emit('show_toast', [1500, self.$t('errorRequestAddress')])

           }

          }).catch(e => {
          // this.errors.push(e);

        })
      },
      save_location() {

      },
      get_phone_prefix() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        console.log();
        const send_data = {
          "UserId": user_id,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPhonePrefixList', send_data, {})
          .then(response => {
            response.data.forEach(function (number) {

              var obj = {value: number.Id, label: number.Code}
              self.phone_code_items.push(obj);
            });

          }).catch(e => {
          this.errors.push(e);

        })

      },
      get_provinces() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        console.log();
        const send_data = {
          "UserId": user_id,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProvincies', send_data, {})
          .then(response => {
            response.data.forEach(function (number) {
              if (number.ProvinceName == "تهران" && self.selected_province == 0) {
                self.selected_province = parseInt(number.ProvinceId);
              }
              var obj = {value: parseInt(number.ProvinceId), label: number.ProvinceName}
              self.province_items.push(obj);
            });

          }).catch(e => {
          // this.errors.push(e);

        })

      },
      get_cities() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        console.log();
        const send_data = {
          "PId": this.selected_province,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetCitiesByProvinceId', send_data, {})
          .then(response => {
            self.city_items = [];
            response.data.cities.forEach(function (number) {
              if (number.CityName == "تهران" && self.selected_city ==0) {
                self.selected_city = parseInt(number.CityId);
              }

              var obj = {value: parseInt(number.CityId), label: number.CityName}
              self.city_items.push(obj);
            });

          }).catch(e => {
          this.errors.push(e);

        })

      },
      get_areas() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        console.log();
        const send_data = {
          "CId": this.selected_city,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetAreas', send_data, {})
          .then(response => {
            self.area_items = [];
            response.data.areas.forEach(function (number) {

              var obj = {value: parseInt(number.AreaRelId), label: number.AreaTitle}
              self.area_items.push(obj);
            });

          }).catch(e => {
          this.errors.push(e);

        })

      },

    }
  };
</script>
<style lang="scss" scoped>
  .basemap {
    width: 100%;
    height: 500px;
  }
</style>
